<agm-marker
  *ngIf="waterwise"
  [latitude]="lat"
  [longitude]="lng"
  [iconUrl]="iconsValidators(waterwise)"
  (mouseOver)="waterwiseInfoWindow.open()"
  (mouseOut)="waterwiseInfoWindow.close()"
  [markerDraggable]="draggable"
  [label]="label ? { color: 'white', text: this.waterwise?.name } : ''"
>
  <ng-container *ngIf="view && type === 'waterwise' && storageService.validateSoloAdmin()">
    <agm-info-window #waterwiseInfoWindow>
      <div class="text-center">
        {{ waterwise.name }} <br /><br />

        <div *ngIf="waterwise.warranty_start_date; else nullWarranty">
          <p>
            {{ "marker.warranty-implementation-date" | translate }}: {{ waterwise ? (waterwise.warranty_start_date | date :
            "yyyy-MM-dd HH:mm") : "" }}
          </p>
          <p>{{ "marker.warranty-months" | translate }}: {{ waterwise.warranty_months ? waterwise.warranty_months : "" }}</p>
          <p>
            {{ "marker.warranty-days-remaining" | translate }}: {{ waterwise.warranty_days_remaining ?
            waterwise.warranty_days_remaining : "" }}
          </p>
        </div>
        <ng-template #nullWarranty>
          <p>{{ "waterwises.no-warranty-date" | translate }}</p>
        </ng-template>
      </div>
    </agm-info-window>
  </ng-container>
</agm-marker>
